export default class DirectionalRecord {
  constructor(directions) {
    this.n = 0;
    this.e = 0;
    this.s = 0;
    this.w = 0;
    this.latestDirection = null;

    if (typeof directions !== 'undefined') {
      if (directions.indexOf('n') !== -1) {
        this.n = 1;
      }
      if (directions.indexOf('e') !== -1) {
        this.e = 1;
      }
      if (directions.indexOf('s') !== -1) {
        this.s = 1;
      }
      if (directions.indexOf('w') !== -1) {
        this.w = 1;
      }
    }
  }

  toString() {
    return (
      '' +
      (!this.n ? '' : 'n') +
      (!this.e ? '' : 'e') +
      (!this.s ? '' : 's') +
      (!this.w ? '' : 'w')
    );
  }

  update(direction) {
    this.latestDirection = direction;
    this[direction] = 1;
  }

  static oppositeDirection(dir) {
    switch (dir) {
      case 'n':
        return 's';
      case 'e':
        return 'w';
      case 's':
        return 'n';
      case 'w':
        return 'e';
      default:
    }
  }

  static coordDelta(dir) {
    switch (dir) {
      case 'n':
        return { x: 0, y: 1 };
      case 'e':
        return { x: 1, y: 0 };
      case 's':
        return { x: 0, y: -1 };
      case 'w':
        return { x: -1, y: 0 };
      default:
    }
  }

  static addDirection(dir, dirs) {
    let dn = !(dirs.indexOf('n') !== -1 || dir === 'n') ? '' : 'n';
    let de = !(dirs.indexOf('e') !== -1 || dir === 'e') ? '' : 'e';
    let ds = !(dirs.indexOf('s') !== -1 || dir === 's') ? '' : 's';
    let dw = !(dirs.indexOf('w') !== -1 || dir === 'w') ? '' : 'w';
    let result = dn + de + ds + dw;
    if (result === '') {
      result = null;
    }
    return result;
  }
}
